module.exports = __webpack_public_path__ + "static/media/iconcoachingcall.fb0864d8.svg";